import { message } from 'antd';
import store from "../../redux/store";
import { getAxiosInstance } from "../ApiConfig";
import { setEmailData } from "../../redux/CrmReduxCalls/EmailConfigCheck";

async function findOneUserEmailConfiguration() {
    try {
        const response = await getAxiosInstance().get(`/findOneUserEmailConfiguration`);
        if (!response.data.data) {
            store.dispatch(setEmailData('EMAIL_SUCCESS', response.data.data, true))
        }
        else {
            store.dispatch(setEmailData('EMAIL_SUCCESS', response.data.data, false))
        }
        return response.data.data
    } catch (err) {
        store.dispatch(setEmailData('EMAIL_FAILURE', err.response.data.message.message))
        throw err.response.data.message.message;
    }
}
async function FetchAllMailService(search) {
    try {
        const response = await getAxiosInstance().get(`/findAllMailServiceByConfig${(search && search !== "") ? `?search=${search}` : ""}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllBulkMailService(search, mail) {
    try {
        const response = await getAxiosInstance().get(`/findAllBulkMailServiceByConfig?isBusinessMail=${mail}${(search && search !== "") ? `&&search=${search}` : ""}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllServiceMailByPagination(folder, page, search) {
    try {
        const response = await getAxiosInstance().get(`/findAllServiceMailByPagination/${page}/${folder}${(search && search !== "") ? `?search=${search}` : ""}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllOutreachMailService(search) {
    try {
        const response = await getAxiosInstance().get(`/findAllOutreachMailService${(search && search !== "") ? `?search=${search}` : ""}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllOutreachMailServiceById(id) {
    try {
        const response = await getAxiosInstance().get(`/findAllOutreachMailServiceByConfig/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllUnReadMail(folder) {
    try {
        const response = await getAxiosInstance().get(`/findAllUnReadMailsCount/${folder}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchStoreAllMails(payload) {
    try {
        const response = await getAxiosInstance().post(`/storeAllMails`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllRecentMails(folder, page, nextLinks, search) {
    const payload = {
        nextLink: nextLinks
    }
    try {
        const response = await getAxiosInstance().post(`/storeAllRecentMails/${folder}/${page}${(search && search !== "") ? `?search=${search}` : ""}`, payload);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllRecentMails1(folder, payload = {}) {
    try {
        const response = await getAxiosInstance().post(`/storeAllRecentMails/${folder}/1`, payload);
        return response;
    } catch (err) {
        message.error("Email connection error. Update your settings to restore access")
    }
};
async function DelteMailFromDB(id) {
    try {
        const data = await getAxiosInstance().delete(`/deleteMailService/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UpdateMailFromDB(payload, id) {
    try {
        const data = await getAxiosInstance().put(`/updateMailService/${id}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function removeMailFromAstraDB(payload, id, action) {
    try {
        const data = await getAxiosInstance().put(`/removeMailFromAstraDB/${id}/${action}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function changeStatusforMails(payload, id) {
    try {
        const data = await getAxiosInstance().put(`/updateEMailActivityStatusToSeen/${id}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TemplateDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/Template/getByTemplateId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchRelatedEmails(id, type, page, limit) {
    try {
        const response = await getAxiosInstance().get(`/findAllEmailActivityByEntityAndId/${id}/${type}?page=${page}&limit=${limit}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchRelatedEmails1(id, type) {
    try {
        const response = await getAxiosInstance().get(`/findAllEmailActivityByEntityAndId/${id}/${type}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function EmailByCamaign(id) {
    try {
        const response = await getAxiosInstance().get(`/findAllCampaignMailServiceByCampaignId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FindSendgridMailsByCampaignId(id) {
    try {
        const response = await getAxiosInstance().get(`/sendgrid/findSendgridMailsByCampaignId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchDetailspage(id, type) {
    try {
        const response = await getAxiosInstance().get(`/Template/fetchEmailDetails/${type}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findOneByMailService(id) {
    try {
        const response = await getAxiosInstance().get(`/findOneByMailService/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AIDefatMessage(companyId, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/getTemplateContentByAI/${companyId}`, payload);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllMyTemplates() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllMyTemplates`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllSharedTemplates() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllSharedTemplates`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteEmailActivity(id) {
    try {
        const data = await getAxiosInstance().delete(`/deleteEmailActivity/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function sendBulkMail(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/sendBulkMail`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function selectEmailTemplate(templateId, type, id) {
    try {
        const response = await getAxiosInstance().get(`/Template/selectEmailTemplate/${templateId}/${type}/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getByTemplateId(templateId) {
    try {
        const response = await getAxiosInstance().get(`/Template/getByTemplateId/${templateId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function sendTemplateMail(linkType, payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/sendTemplateMail/${linkType}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function moveToTrashFromInbox(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/moveToTrashFromInbox`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function moveToTrashFromSent(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/moveToTrashFromSent`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function moveToTrashFromSpam(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/moveToTrashFromSpam`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function moveSpamToInbox(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/moveSpamToInbox`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteEmailFromTrash(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/deleteEmailFromTrash`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteDraft(payload) {
    try {
        const response = await getAxiosInstance().delete(`/Template/deleteDraft`, { data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function restoreEmailFromTrash(payload, position) {
    try {
        const data = await getAxiosInstance().put(`/Template/restoreEmailFromTrash/${position}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function linkEmailForCase(payload) {
    try {
        const response = await getAxiosInstance().post(`/linkEmailForCase`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function linkEmailForLead(payload) {
    try {
        const response = await getAxiosInstance().post(`/linkEmailForLead`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function linkEmailForDeal(payload) {
    try {
        const response = await getAxiosInstance().post(`/linkEmailForDeal`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateDealActivity(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/updateDealActivity/${id}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findExistLinkDeal(mailId) {
    try {
        const response = await getAxiosInstance().get(`/findExistLinkDeal/${mailId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function sendDraftEmail(id, linkType, payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/sendDraftEmail/${id}/${linkType}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateDraftEmail(payload, id) {
    try {
        const data = await getAxiosInstance().put(`/Template/updateDraftEmail/${id}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function saveDraft(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/saveDraft`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllTemplateGroupByUser() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllTemplateGroupByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteTemplate(id) {
    try {
        const response = await getAxiosInstance().delete(`/Template/deleteTemplate/${id}`)
        return response;
    } catch (err) {
        throw err.response.data.message;
    }
}
async function updateTemplate(payload, drawerId) {
    try {
        const data = await getAxiosInstance().put(`/Template/updateTemplate/${drawerId}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createTemplate(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createTemplate`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createTemplateGroup(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createTemplateGroup`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateTemplateGroup(payload, drawerId) {
    try {
        const data = await getAxiosInstance().put(`/Template/updateTemplateGroup/${drawerId}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createReportingGroup(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createReportingGroup`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findEmailSummaryByEntity(entityId, entityType) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findEmailSummaryByEntity/${entityId}/${entityType}`);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function executeEmailSummary(entityId, entityType, payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/executeEmailSummary/${entityId}/${entityType}`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function updateReportingGroup(payload, drawerId) {
    try {
        const data = await getAxiosInstance().put(`/Template/updateReportingGroup/${drawerId}`, payload);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getByTemplateGroupId(id) {
    try {
        const response = await getAxiosInstance().get(`/Template/getByTemplateGroupId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteTemplateGroup(id) {
    try {
        const response = await getAxiosInstance().delete(`/Template/deleteTemplateGroup/${id}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getByReportingGroupId(id) {
    try {
        const response = await getAxiosInstance().get(`/Template/getByReportingGroupId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getAllTemplateByTemplateGroupId(id) {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllTemplateByTemplateGroupId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteReportingGroup(id) {
    try {
        const response = await getAxiosInstance().delete(`/Template/deleteReportingGroup/${id}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function GetBulkMailSendReportLog(name) {
    const payload = { subject: name };
    try {
        const response = await getAxiosInstance().post(`/bulkMailSendReportLog`, payload);
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    FindSendgridMailsByCampaignId,
    linkEmailForLead,
    executeEmailSummary,
    findEmailSummaryByEntity,
    findExistLinkDeal,
    updateDealActivity,
    linkEmailForDeal,
    getAllTemplateByTemplateGroupId,
    FetchRelatedEmails1,
    getByTemplateGroupId,
    getByReportingGroupId,
    deleteTemplateGroup,
    deleteReportingGroup,
    createTemplateGroup,
    updateReportingGroup,
    createReportingGroup,
    updateTemplateGroup,
    createTemplate,
    updateTemplate,
    deleteTemplate,
    getAllTemplateGroupByUser,
    updateDraftEmail,
    saveDraft,
    sendDraftEmail,
    deleteDraft,
    linkEmailForCase,
    restoreEmailFromTrash,
    moveToTrashFromInbox,
    moveToTrashFromSent,
    moveToTrashFromSpam,
    moveSpamToInbox,
    deleteEmailFromTrash,
    getByTemplateId,
    selectEmailTemplate,
    sendTemplateMail,
    sendBulkMail,
    deleteEmailActivity,
    FetchAllMailService,
    FetchStoreAllMails,
    FetchAllRecentMails,
    FetchAllRecentMails1,
    DelteMailFromDB,
    UpdateMailFromDB,
    removeMailFromAstraDB,
    FetchAllBulkMailService,
    TemplateDetailData,
    FetchRelatedEmails,
    FetchDetailspage,
    changeStatusforMails,
    findOneByMailService,
    EmailByCamaign,
    findAllServiceMailByPagination,
    AIDefatMessage,
    FetchAllUnReadMail,
    getAllMyTemplates,
    getAllSharedTemplates,
    findAllOutreachMailService,
    findAllOutreachMailServiceById,
    findOneUserEmailConfiguration,
    GetBulkMailSendReportLog,
}